export interface IHeaderOneTextProps {text: string}

const HeaderOneText: React.FC<IHeaderOneTextProps> = ({text}) => {
    return <h1 className={"standardText overflowEllipsis fontHeader"}>{text}</h1>
}

export default HeaderOneText;